import React, { useMemo } from "react";

/**
 * Lightweight CSS-only drone-like particle field.
 * Uses CSS custom properties to randomise drift trajectories.
 */
export const Particles = ({ count = 40, className = "" }) => {
  const particles = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const left = Math.random() * 100;
      const top = Math.random() * 100;
      const dx = (Math.random() - 0.5) * 200;
      const dy = -(Math.random() * 220 + 40);
      const duration = 6 + Math.random() * 9;
      const delay = Math.random() * 8;
      const size = 2 + Math.random() * 3;
      const hue = Math.random() > 0.75 ? "#ffffff" : "#007AFF";
      return { i, left, top, dx, dy, duration, delay, size, hue };
    });
  }, [count]);

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {particles.map((p) => (
        <span
          key={p.i}
          className="drone-particle"
          style={{
            left: `${p.left}%`,
            top: `${p.top}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            background: p.hue,
            boxShadow: `0 0 12px 2px ${p.hue}cc, 0 0 28px 6px ${p.hue}55`,
            ["--dx"]: `${p.dx}px`,
            ["--dy"]: `${p.dy}px`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default Particles;
